import { DateRange } from '@emi/shared/models';

export class DatePickerSettings {
    constructor(
        public dateRange: DateRange,
        public rangeLimits: DateRange
    ) {}
}
